import { render, staticRenderFns } from "./ValitorCardLogos.vue?vue&type=template&id=5291e78c&scoped=true"
import script from "./ValitorCardLogos.vue?vue&type=script&lang=js"
export * from "./ValitorCardLogos.vue?vue&type=script&lang=js"
import style0 from "./ValitorCardLogos.vue?vue&type=style&index=0&id=5291e78c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5291e78c",
  null
  
)

export default component.exports